import { createClient } from '@supabase/supabase-js'

export const supabaseCirculoAnimal = createClient(
  process.env.REACT_APP_SUPABASE_URL_CIRCULO_ANIMAL,
  process.env.REACT_APP_SUPABASE_ANON_KEY_CIRCULO_ANIMAL,
  {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      storageKey: 'ca-auth'
    }
  }
)
